import { BaseFileInformation, FileType } from 'owa-group-files-hub-store';
import { PerformanceDatapoint } from 'owa-analytics';

export function logFileListInformation(
    fileList: BaseFileInformation[],
    datapoint: PerformanceDatapoint
) {
    const fileTypeCount: { [key: string]: number } = {};
    const fileExtensionCount: { [key: string]: number } = {};

    datapoint.addCustomData({
        NumberOfFiles: fileList.length.toString(),
    });

    for (const file of fileList) {
        if (fileTypeCount.hasOwnProperty(FileType[file.fileType])) {
            fileTypeCount[FileType[file.fileType]] = fileTypeCount[FileType[file.fileType]] + 1;
        } else {
            fileTypeCount[FileType[file.fileType]] = 1;
        }

        if (fileExtensionCount.hasOwnProperty(file.extension)) {
            fileExtensionCount[file.extension] = fileExtensionCount[file.extension] + 1;
        } else {
            fileExtensionCount[file.extension] = 1;
        }
    }

    datapoint.addCustomData({
        FileTypeCount: JSON.stringify(fileTypeCount),
    });

    datapoint.addCustomData({
        FileExtensionCount: JSON.stringify(fileExtensionCount),
    });
}
